<template>
  <v-card>
    <v-tabs :value="tabMenu">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchTranList()">{{transactionType}} List</v-tab>
      <v-tab v-show="displayReviewTab" @click="fetchDetails()">Details</v-tab>
      <v-tab v-show="displayReviewTab" @click="fetchApplicant()">Applicant</v-tab>
      <v-tab v-show="displayReviewTab && misc" @click="fetchMisc()">{{miscText}}</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayReviewTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayReviewTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayReviewTab && misc">
        <transition name="slide-x-transition" mode="out-in">
          <router-view :key="routeKey"></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    this.fetchTranList()
  },
  watch: {
    'appID'(value) {
      this.fetchTranList()
    }
  },
  methods: {
    fetchTranList() {
      const commitData = {
        tabMenu: 0,
        displayReviewTab: false
      }
      this.$store.commit('TABMENU', commitData)
      if (this.appID === 'TR') {
        this.$router.push({ name: 'travelTranList' })
      } else if (this.appID === 'FI') {
        this.$router.push({ name: 'fireTranList' })
      } else if (this.appID === 'MD') {
        this.$router.push({ name: 'maidTranList' })
      }
    },
    fetchDetails() {
      const commitData = {
        tabMenu: 1,
        displayReviewTab: true
      }
      this.$store.commit('TABMENU', commitData)
      if (this.appID === 'TR') {
        this.$router.push({ name: 'travelTrans' })
      } else if (this.appID === 'FI') {
        this.$router.push({ name: 'fireTrans' })
      } else if (this.appID === 'MD') {
        this.$router.push({ name: 'maidTrans' })
      }
    },
    fetchApplicant() {
      const commitData = {
        tabMenu: 2,
        displayReviewTab: true
      }
      this.$store.commit('TABMENU', commitData)
      this.$router.push({ name: 'applicant' })
    },
    fetchMisc() {
      const commitData = {
        tabMenu: 3,
        displayReviewTab: true
      }
      this.$store.commit('TABMENU', commitData)
      if (this.appID === 'MD') {
        this.$router.push({ name: 'domesticWorker' })
      } else if (this.appID === 'TR') {
        this.$router.push({ name: 'insured' })
      }
    }
  },
  computed: {
    tabMenu() {
      return this.$store.state.adminMember.member.tabMenu.tab
    },
    displayReviewTab() {
      return this.$store.state.adminMember.member.tabMenu.displayReviewTab
    },
    misc() {
      return this.$store.state.adminMember.member.tabMiscMenu.display
    },
    miscText() {
      return this.$store.state.adminMember.member.tabMiscMenu.text
    },
    routeKey() {
      if (this.$route.matched && this.$route.matched.length > 0) {
        // This is to solve the route loading fail for pages with same component
        // Eg: SubRoute - Vue JS will reuse same component for same route level, thus not triggering the lifeCycle methods
        // Note: this will only solve the problem for index 0 route
        return this.$route.matched[0].name
      }
      return ''
    },
    transactionType() {
      if (this.appID === 'TR') {
        return 'Travel Transaction'
      } else if (this.appID === 'MD') {
        return 'Maid Transaction'
      } else if (this.appID === 'FI') {
        return 'Fire Transaction'
      } else {
        return ''
      }
    },
    miscTab() {
      return this.$store.state.adminMember.member.subMember.misc
    }
  },
  props: ['id', 'appID']
}
</script>

<style>
</style>
